'use client';

import type { IndustrialCaseDocument } from '@/domain/industrialCase/industrialCaseDocument';
import type { IndustrialCaseSummary } from '@/domain/industrialCase/industrialCaseSummary';

import ResponsiveLayout from '@/components/apps/layouts/responsive/Layout';
import { IndustrialCaseDetailPage } from '@/components/apps/pages/solution/industrial/IndustrialCaseDetailPage';
import { useIndustrialCaseAnalytics } from '@/components/apps/pages/solution/industrial/useIndustrialCaseAnalytics';
import VisuallyHiddenPageTitle from '@/components/apps/ui/a11y/VisuallyHiddenPageTitle';

export default function IndustrialCasePageClient({
  caseDocument,
  relatedCases,
}: {
  caseDocument: IndustrialCaseDocument;
  relatedCases: ReadonlyArray<IndustrialCaseSummary>;
}) {
  const reportSelection = useIndustrialCaseAnalytics({
    slug: caseDocument.slug,
    solution: caseDocument.solution,
    industry: caseDocument.industry,
  });

  return (
    <>
      <VisuallyHiddenPageTitle>{caseDocument.title}</VisuallyHiddenPageTitle>
      <ResponsiveLayout mobilePadding={{ top: '0', bottom: '0' }}>
        <IndustrialCaseDetailPage
          caseDocument={caseDocument}
          relatedCases={relatedCases}
          onSelectContent={reportSelection}
        />
      </ResponsiveLayout>
    </>
  );
}
